import { getAllowedOrigins } from '../../config';
import { getDeferred } from '../../utils';
import { relayOperations } from './operations';
const waitForMagpieProbeReply = id => {
  const {
    promise,
    resolve
  } = getDeferred();
  let timer = null;
  const listener = event => {
    if (relayOperations.probeReply.match(event.data) && event.data.payload.replyTo === id && getAllowedOrigins().includes(event.origin)) {
      window.removeEventListener('message', listener);
      if (timer) {
        clearTimeout(timer);
      }
      resolve({
        origin: event.origin,
        brokerId: event.data.payload.brokerId
      });
    }
  };
  timer = setTimeout(() => {
    window.removeEventListener('message', listener);
    return resolve(null);
  }, 250);
  window.addEventListener('message', listener);
  return promise;
};

/* Note about the implementation:
 * It's safe to use `*` as target origin for probe - we only accept replies from
 * allowed origins (i.e., the promise won't resolve if the replier's origin is
 * invalid). On the other hand, the proxy only listens to messages from allowed
 * origins. The message carries no sensitive information. Iterating over allowed
 * origins would result in a number of warnings.
 */
export const checkIfHasBrokerProxy = scope => {
  const probeMessage = relayOperations.probe();
  const isUsingMagpiePromise = waitForMagpieProbeReply(probeMessage.id);
  scope.postMessage(probeMessage, '*');
  return isUsingMagpiePromise;
};